export const SUBACCOUNT_SORTS = [
  {
    key: "name_asc",
    label: "Name, A-Z"
  },
  {
    key: "name_desc",
    label: "Name, Z-A"
  },
  {
    key: "created_at_desc",
    label: "Created At, Newest First"
  },
  {
    key: "created_at_asc",
    label: "Created At, Oldest First"
  }
] as const;

export type SubaccountSort = (typeof SUBACCOUNT_SORTS)[number]["key"];
